import React, { ReactElement } from 'react';
import { useLocation, useParams } from 'react-router';
import { Breadcrumbs, homeBreadcrumb } from 'slovlex-idsk-react-components';
import { Loader } from 'idsk-react-components';
import Layout from '../../Layout';
import routes from '../../../routing/routes';
import GlobalErrors from '../../../module/GlobalErrors';
import SecuredPage from '../../../module/SecuredPage';
import UserRoleEnum from '../../../model/currentuser/UserRole';
import PageHeadingWithBackButton from '../../../module/PageHeadingWithBackButton';
import TezaurusEditForm from '../../../module/Admin/Tezaurus/Edit/TezaurusEditForm';
import useTezaurusDetail from '../../../hooks/useTezaurusDetail';

const TezaurusEditPage = (): ReactElement => {
  const { pathname } = useLocation();
  const { uuid } = useParams();
  const { tezaurus, tezaurusStatus } = useTezaurusDetail(uuid);
  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          to: routes.tezaurus.admin.list,
          heading: 'Administrácia tezaurov',
        },
        {
          to: pathname,
          heading: 'Úprava tezauru',
        },
      ]}
      />
      <GlobalErrors />
      <Loader loading={tezaurusStatus.loading}>
        {tezaurusStatus.finished && (
          <SecuredPage
            allowForRoles={[UserRoleEnum.ADMINISTRATOR_TEZAURUS]}
            requestStatus={tezaurusStatus?.responseCode}
          >
            <>
              {tezaurus && (
                <>
                  <PageHeadingWithBackButton heading="Úprava tezauru" />
                  <TezaurusEditForm tezaurusData={tezaurus} />
                </>
              )}
            </>
          </SecuredPage>
        )}
      </Loader>
    </Layout>
  );
};

export default TezaurusEditPage;
